import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Shield, Factory, Truck, Building2, Sprout, Heart } from 'lucide-react';

const Industries = () => {
  const industries = [
    { icon: Shield, title: 'Critical Infrastructure', desc: 'Reduce blind spots. Standardise response. Strengthen evidence trails.', image: 'https://images.unsplash.com/photo-1536099629323-44806c1ea264?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxpbmZyYXN0cnVjdHVyZXxlbnwwfHx8fDE3Njc0NDM2NDN8MA&ixlib=rb-4.1.0&q=85' },
    { icon: Factory, title: 'Industrial & Warehousing', desc: 'Safety visibility, repeatable execution, audit-ready documentation.', image: 'https://images.unsplash.com/photo-1740914994657-f1cdffdc418e' },
    { icon: Truck, title: 'Logistics Yards & Transport', desc: 'Movement patterns, restricted zones, incident traceability at scale.', image: 'https://images.unsplash.com/photo-1606964212858-c215029db704?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxsb2dpc3RpY3N8ZW58MHx8fHwxNzY3NDQzNjUwfDA&ixlib=rb-4.1.0&q=85' },
    { icon: Building2, title: 'Smart Campuses & Commercial', desc: 'Occupancy awareness, situational oversight, faster investigations.', image: 'https://images.pexels.com/photos/269077/pexels-photo-269077.jpeg' },
    { icon: Sprout, title: 'Agriculture & Plantations', desc: 'Field operations visibility, reporting, and practical deployment models.', image: 'https://images.unsplash.com/photo-1560493676-04071c5f467b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQyMTd8MHwxfHNlYXJjaHwxfHxhZ3JpY3VsdHVyZSUyMGZhcm18ZW58MHx8fHwxNzY3NDQzNjAyfDA&ixlib=rb-4.1.0&q=85' },
    { icon: Heart, title: 'Healthcare (WIP)', desc: 'Coming soon.', badge: 'WIP' }
  ];

  return (
    <div className="min-h-screen">
      <section className="pt-32 pb-20 px-6">
        <div className="max-w-6xl mx-auto text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <h1 className="heading-1 mb-6">Built for places where clarity matters.</h1>
          </motion.div>
        </div>
      </section>

      <section className="pb-20 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {industries.map((industry, i) => (
              <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }} className="product-card group">
                {industry.image && (
                  <div className="w-full h-48 mb-4 rounded-lg overflow-hidden">
                    <img src={industry.image} alt={industry.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
                  </div>
                )}
                <div className="flex items-start justify-between mb-3">
                  <industry.icon className="w-10 h-10 text-[var(--accent-primary)]" />
                  {industry.badge && <span className="text-xs px-2 py-1 bg-[var(--accent-wash)] text-[var(--accent-text)] rounded-full">{industry.badge}</span>}
                </div>
                <h3 className="heading-3 mb-2">{industry.title}</h3>
                <p className="text-[var(--text-secondary)]">{industry.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <Link to="/contact" className="btn-primary">Talk to an Expert</Link>
        </div>
      </section>
    </div>
  );
};

export default Industries;